import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ApiResponse } from '../services/createConfigService'

export interface CreateConfigurationState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null | undefined
}

const initialState: CreateConfigurationState = {
  isLoading: true,
  error: null,
  httpStatus: null
}

const createConfigurationSlice = createSlice({
  name: 'configuration-template',
  initialState,
  reducers: {
    createConfigurationLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0
      }
    },
    createConfigurationUpdateAction: (state, action: PayloadAction<{ data: ApiResponse }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.data.http_status
      }
    },
    createConfigurationErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  createConfigurationLoadingAction,
  createConfigurationUpdateAction,
  createConfigurationErrorAction
} = createConfigurationSlice.actions

export default createConfigurationSlice.reducer
